import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
// ✅ CHANGED: Removed IServerSideGetRowsParams → IDatasource + IGetRowsParams
import { ColDef, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { ServerRequest } from 'src/app/_models/global.data.model';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { TableHeaderToolTipComponent } from '../../table-header-tool-tip/table-header-tool-tip.component';
import { JobOrdersService } from 'src/app/_services/job-orders.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

var translateData: any;

@Component({
  selector: 'app-custella-jo-template',
  templateUrl: './custella-jo-template.component.html',
  styleUrls: ['./custella-jo-template.component.scss'],
  standalone: false,
})
export class CustellaJoTemplateComponent extends SubscriptionUtil implements OnInit, OnDestroy {

  @Output() itemSelector = new EventEmitter();
  @Output() closeView = new EventEmitter();

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any;
  defaultColDef: any;
  frameworkComponents: any;
  gridParams: any;
  startFrom: any;
  product: any;
  pageSize: any = 25;
  parameters: any;
  gridOptions: any;
  overlayNoRowsTemplate: string;
  productsFamilies: any;
  productsType: any;
  currentRecordNumber: any;
  totalRecord: any;
  searchValue: any = null;
  checklistData: any;
  translate: any;

  constructor(
    private jobOrdersService: JobOrdersService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
  ) {
    super();

    this.gridOptions = {
      cacheBlockSize: 25,
      rowModelType: "infinite",
      sortingOrder: ["desc", "asc"],
      onGridSizeChanged: (params: any) => { params.api.sizeColumnsToFit(); },
      tooltipShowDelay: 100,
     
    };

    this.defaultColDef = {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };
  }

  ngOnInit(): void {
    this.push(
      this.languageTranslateService.menuSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          translateData = data;
          this.initializeColumns();
        }
      })
    );
  }

  ngOnDestroy(): void { super.ngOnDestroy(); }

  /********************************** Cell Click **************************/
  public viewCell($event: any) {
    if ($event.colDef.field === "templateName") { this.selectItem($event.data); }
  }

  selectItem(val: any) { this.itemSelector.emit(val); }
  public closeTable() { this.closeView.emit(false); }
  push(obs: any) { super.push(obs); }

  /********************************** Search **************************/
  quickSearch() { this.onGridReady(this.gridParams); }

  /********************************** On Grid Ready **************************/
  onGridReady(params: any) {
    this.gridParams = params;
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();

    // ✅ CHANGED: IDatasource with IGetRowsParams
    const dataSource: IDatasource = {
      getRows: (params: IGetRowsParams) => {
        this.getServerSideData(params);
      },
    };

    this.gridApi.sizeColumnsToFit();
    // ✅ UNCHANGED: setGridOption("datasource") already correct
    this.gridApi.setGridOption("datasource", dataSource);
  }

  /********************************** Get Server Side Data **************************/
  // ✅ CHANGED: IServerSideGetRowsParams → IGetRowsParams
  getServerSideData(agGridGetRowsParams: IGetRowsParams) {
    this.gridApi.hideOverlay();
    const serverRequest = this.getRequestParams(agGridGetRowsParams);

    this.push(
      this.jobOrdersService.getAllJobOrderTemplates(this.searchValue, serverRequest, null, null, null, null, null, "ACTIVE").subscribe(
        (data: any) => {
          this.checklistData = data.body.data;
          this.totalRecord = data.body.total;
          this.setGridData(agGridGetRowsParams, this.checklistData, data.body.total, data.body.status);
        },
        (err) => { this.errorUtil.setErrorMessage(err); }
      )
    );
  }

  /********************************** Set Grid Data **************************/
  // ✅ CHANGED: IServerSideGetRowsParams → IGetRowsParams
  // ✅ CHANGED: .success({rowData, rowCount}) → successCallback()
  private setGridData(
    agGridGetRowsParams: IGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    if (this.checklistData.length === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      // ✅ CHANGED: successCallback replaces .success({rowData, rowCount})
      agGridGetRowsParams.successCallback(this.checklistData, totalCount);
    }
  }

  /********************************** Request Params **************************/
  getRequestParams(agGridRequest: any): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: "fault.name", sort: "asc" };
      agGridRequest.sortModel.push(this.parameters);
    }

    this.currentRecordNumber = agGridRequest.startRow;
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }

  /********************************** Initialize Columns **************************/
  initializeColumns() {
    this.columnDefs = [];
    this.overlayNoRowsTemplate =
      "<div class='not-found'><span>" + this.translate?.general.messages.noRecordsFound + "</span> </div>";

    const newData = [
      { headerName: this.translate?.setup.modules.templates.fields.templateName.singular, field: 'templateName', width: 150, headerTooltip: "#", cellClass: function (params: any) { return ['table_default_color']; } },
      { headerName: this.translate?.jobOrder.label.singular + " " + this.translate?.jobOrder.fields.name.singular, field: 'jobOrderName', width: 170, headerTooltip: "#" },
      { headerName: this.translate?.jobOrder.fields.type.singular, field: 'site.name', width: 80, headerTooltip: "#" },
      { headerName: this.translate?.jobOrder.fields.system.singular, field: 'systemValue.name', width: 100, headerTooltip: "#" },
      { headerName: this.translate?.jobOrder.fields.fault.singular, field: 'fault.name', width: 100, headerTooltip: "#" },
      { headerName: this.translate?.setup.serviceZone.label.singular, field: 'serviceZone.name', width: 100, headerTooltip: "#" },
      {
        headerName: this.translate?.setup.modules.templates.fields.status.singular,
        field: 'active',
        width: 100,
        headerTooltip: "#",
        cellRenderer: function (params: any) {
          if (params.data) {
            if (params.data.templateStatus == 'ACTIVE') {
              return '<span class="p-mr-2  p-tag p-component p-tag-success" ><span class="p-tag-value">' + translateData.general.status.active.singular + '</span></span>';
            } else {
              return '<span class="p-mr-2  p-tag p-component p-tag-danger" ><span class="p-tag-value text-dark">' + translateData.general.status.inactive.singular + '</span></span>';
            }
          }
        },
      },
    ];

    this.columnDefs = newData;
    // ✅ CHANGED: setColumnDefs() → setGridOption("columnDefs", ...)
    if (this.gridApi) {
      this.gridApi.setGridOption("columnDefs", this.columnDefs);
      setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 500);
    }
  }
}